import { FC } from "react";
import { Chart } from "components/charts/Chart";
import { LineChart } from "components/charts/LineChart";
import type { NormalizedStat } from "../utils";

type StatChartsProps = {
  chartStats: NormalizedStat[];
  lineStats: NormalizedStat[];
};

export const StatCharts: FC<StatChartsProps> = ({ chartStats, lineStats }) => {
  const hasCharts = chartStats.length > 0;
  const hasLines = lineStats.length > 0;

  if (!hasCharts && !hasLines) return null;

  return (
    <>
      {hasCharts && (
        <div className="flex w-full flex-row items-stretch justify-center gap-[2vw]">
          {chartStats.map((stat) => (
            <Chart
              key={stat.key}
              title={stat.title}
              homeValue={stat.homeValue}
              awayValue={stat.awayValue}
              valueFormatter={stat.valueFormatter}
            />
          ))}
        </div>
      )}

      {hasLines && (
        <div className="flex w-full flex-col gap-[1.5vw]">
          {lineStats.map((stat) => (
            <LineChart
              key={stat.key}
              title={stat.title}
              homeValue={stat.homeValue}
              awayValue={stat.awayValue}
              valueFormatter={stat.valueFormatter}
            />
          ))}
        </div>
      )}
    </>
  );
};
